<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Tisk&aacute;rny C2326, C3224, C3326, C3426, CS331, CS431, CS439">
     Tisk&aacute;rny C2326, C3224, C3326, C3426, CS331, CS431, CS439
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_cs" title="Informace o&nbsp;bezpečnosti">
     Informace o&nbsp;bezpečnosti
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konvence">
      Konvence
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Upozorněn&iacute; produktu">
      Upozorněn&iacute; produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_cs" title="Informace o&nbsp;tisk&aacute;rně">
     Informace o&nbsp;tisk&aacute;rně
    </a>
   </p>
   <div id="divd0e173">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_cs" title="Vyhled&aacute;n&iacute; informac&iacute; o tisk&aacute;rně">
      Vyhled&aacute;n&iacute; informac&iacute; o tisk&aacute;rně
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_cs" title="Zji&scaron;těn&iacute; s&eacute;riov&eacute;ho č&iacute;sla tisk&aacute;rny">
      Zji&scaron;těn&iacute; s&eacute;riov&eacute;ho č&iacute;sla tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_cs" title="Konfigurace tisk&aacute;rny">
      Konfigurace tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_cs" title="Použit&iacute; ovl&aacute;dac&iacute;ho panelu">
      Použit&iacute; ovl&aacute;dac&iacute;ho panelu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_cs" title="Přizpůsoben&iacute; domovsk&eacute; obrazovky">
      Přizpůsoben&iacute; domovsk&eacute; obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_cs" title="Popis stavu kontrolky">
      Popis stavu kontrolky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e627" title="V&yacute;běr pap&iacute;ru">
      V&yacute;běr pap&iacute;ru
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_cs" title="Nastaven&iacute;, instalace a konfigurace">
     Nastaven&iacute;, instalace a konfigurace
    </a>
   </p>
   <div id="divd0e1351">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_cs" title="V&yacute;běr um&iacute;stěn&iacute; tisk&aacute;rny">
      V&yacute;běr um&iacute;stěn&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_cs" title="Zapojov&aacute;n&iacute; kabelů">
      Zapojov&aacute;n&iacute; kabelů
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_cs" title="Instalace voliteln&yacute;ch z&aacute;sobn&iacute;ků">
      Instalace voliteln&yacute;ch z&aacute;sobn&iacute;ků
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1549" title="Nastaven&iacute; a použit&iacute; aplikac&iacute; spou&scaron;těn&yacute;ch z&nbsp;domovsk&eacute; obrazovky">
      Nastaven&iacute; a použit&iacute; aplikac&iacute; spou&scaron;těn&yacute;ch z&nbsp;domovsk&eacute; obrazovky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e1676" title="Zakl&aacute;d&aacute;n&iacute; pap&iacute;ru a speci&aacute;ln&iacute;ch m&eacute;di&iacute;">
      Zakl&aacute;d&aacute;n&iacute; pap&iacute;ru a speci&aacute;ln&iacute;ch m&eacute;di&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e1851" title="Instalace a&nbsp;aktualizace softwaru, ovladačů a&nbsp;firmwaru">
      Instalace a&nbsp;aktualizace softwaru, ovladačů a&nbsp;firmwaru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e2111" title="Pr&aacute;ce v&nbsp;s&iacute;ti">
      Pr&aacute;ce v&nbsp;s&iacute;ti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_cs" title="Tisk str&aacute;nky nastaven&iacute; nab&iacute;dek">
      Tisk str&aacute;nky nastaven&iacute; nab&iacute;dek
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_cs" title="Zabezpečen&iacute; tisk&aacute;rny">
     Zabezpečen&iacute; tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e2556">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_cs" title="Vymaz&aacute;n&iacute; paměti tisk&aacute;rny">
      Vymaz&aacute;n&iacute; paměti tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_cs" title="Obnoven&iacute; v&yacute;choz&iacute;ch tov&aacute;rn&iacute;ch nastaven&iacute;">
      Obnoven&iacute; v&yacute;choz&iacute;ch tov&aacute;rn&iacute;ch nastaven&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_cs" title="Prohl&aacute;&scaron;en&iacute; o nest&aacute;losti">
      Prohl&aacute;&scaron;en&iacute; o nest&aacute;losti
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_cs" title="Tisk">
     Tisk
    </a>
   </p>
   <div id="divd0e2678">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_cs" title="Tisk z&nbsp;poč&iacute;tače">
      Tisk z&nbsp;poč&iacute;tače
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2704" title="Tisk pomoc&iacute; mobiln&iacute;ho zař&iacute;zen&iacute;">
      Tisk pomoc&iacute; mobiln&iacute;ho zař&iacute;zen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_cs" title="Konfigurace důvěrn&yacute;ch &uacute;loh">
      Konfigurace důvěrn&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_cs" title="Tisk důvěrn&yacute;ch a&nbsp;jin&yacute;ch pozdržen&yacute;ch &uacute;loh">
      Tisk důvěrn&yacute;ch a&nbsp;jin&yacute;ch pozdržen&yacute;ch &uacute;loh
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_cs" title="Tisk z&nbsp;profilu Cloud Connector">
      Tisk z&nbsp;profilu Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_cs" title="Tisk seznamu uk&aacute;zek p&iacute;sma">
      Tisk seznamu uk&aacute;zek p&iacute;sma
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_cs" title="Um&iacute;stěn&iacute; oddělovac&iacute;ch listů mezi kopie">
      Um&iacute;stěn&iacute; oddělovac&iacute;ch listů mezi kopie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_cs" title="Zru&scaron;en&iacute; tiskov&eacute; &uacute;lohy">
      Zru&scaron;en&iacute; tiskov&eacute; &uacute;lohy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_cs" title="Nastaven&iacute; sytosti toneru">
      Nastaven&iacute; sytosti toneru
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_cs" title="Použit&iacute; nab&iacute;dek tisk&aacute;rny">
     Použit&iacute; nab&iacute;dek tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e3246">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_cs" title="Sch&eacute;ma nab&iacute;dek">
      Sch&eacute;ma nab&iacute;dek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3503" title="Zař&iacute;zen&iacute;">
      Zař&iacute;zen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e4995" title="Tisk">
      Tisk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e5943" title="Pap&iacute;r">
      Pap&iacute;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6183" title="S&iacute;ť/porty">
      S&iacute;ť/porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8173" title="Zabezpečen&iacute;">
      Zabezpečen&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_cs" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e8829" title="Zpr&aacute;vy">
      Zpr&aacute;vy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_cs" title="Ře&scaron;en&iacute; probl&eacute;mů">
      Ře&scaron;en&iacute; probl&eacute;mů
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_cs" title="&Uacute;držba tisk&aacute;rny">
     &Uacute;držba tisk&aacute;rny
    </a>
   </p>
   <div id="divd0e9032">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_cs" title="Kontrola stavu č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu">
      Kontrola stavu č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_cs" title="Konfigurace upozorňov&aacute;n&iacute; na spotřebn&iacute; materi&aacute;l">
      Konfigurace upozorňov&aacute;n&iacute; na spotřebn&iacute; materi&aacute;l
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_cs" title="Nastaven&iacute; e-mailov&yacute;ch upozorněn&iacute;">
      Nastaven&iacute; e-mailov&yacute;ch upozorněn&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_cs" title="Zobrazen&iacute; zpr&aacute;v">
      Zobrazen&iacute; zpr&aacute;v
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_cs" title="Objedn&aacute;n&iacute; č&aacute;st&iacute; a&nbsp;spotřebn&iacute;ho materi&aacute;lu">
      Objedn&aacute;n&iacute; č&aacute;st&iacute; a&nbsp;spotřebn&iacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e9851" title="V&yacute;měna č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu">
      V&yacute;měna č&aacute;st&iacute; a spotřebn&iacute;ho materi&aacute;lu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e10049" title="Či&scaron;těn&iacute; č&aacute;st&iacute; tisk&aacute;rny">
      Či&scaron;těn&iacute; č&aacute;st&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e10170" title="&Uacute;spora energie a&nbsp;pap&iacute;ru">
      &Uacute;spora energie a&nbsp;pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_cs" title="Přem&iacute;stěn&iacute; tisk&aacute;rny">
      Přem&iacute;stěn&iacute; tisk&aacute;rny
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_cs" title="Přeprava tisk&aacute;rny">
      Přeprava tisk&aacute;rny
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_cs" title="Ře&scaron;en&iacute; probl&eacute;mu">
     Ře&scaron;en&iacute; probl&eacute;mu
    </a>
   </p>
   <div id="divd0e10331">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_cs" title="Probl&eacute;my s&nbsp;kvalitou tisku">
      Probl&eacute;my s&nbsp;kvalitou tisku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e10431" title="Probl&eacute;my s&nbsp;tiskem">
      Probl&eacute;my s&nbsp;tiskem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_cs" title="Tisk&aacute;rna nereaguje.">
      Tisk&aacute;rna nereaguje.
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e12836" title="Probl&eacute;my se s&iacute;ťov&yacute;m připojen&iacute;m">
      Probl&eacute;my se s&iacute;ťov&yacute;m připojen&iacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e13055" title="Probl&eacute;my se spotřebn&iacute;m materi&aacute;lem">
      Probl&eacute;my se spotřebn&iacute;m materi&aacute;lem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_cs" title="Odstraněn&iacute; zaseknut&eacute;ho pap&iacute;ru">
      Odstraněn&iacute; zaseknut&eacute;ho pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e13492" title="Pot&iacute;že s&nbsp;pod&aacute;v&aacute;n&iacute;m pap&iacute;ru">
      Pot&iacute;že s&nbsp;pod&aacute;v&aacute;n&iacute;m pap&iacute;ru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e13874" title="Pot&iacute;že s&nbsp;kvalitou barev">
      Pot&iacute;že s&nbsp;kvalitou barev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_cs" title="Kontaktov&aacute;n&iacute; z&aacute;kaznick&eacute; podpory">
      Kontaktov&aacute;n&iacute; z&aacute;kaznick&eacute; podpory
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_cs" title="Recyklace a likvidace">
     Recyklace a likvidace
    </a>
   </p>
   <div id="divd0e14113">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_cs" title="Recyklace produktů společnosti Lexmark">
      Recyklace produktů společnosti Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_cs" title="Recyklace obalů společnosti Lexmark">
      Recyklace obalů společnosti Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_cs" title="Pozn&aacute;mky">
     Pozn&aacute;mky
    </a>
   </p>
   <div id="divd0e14148">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14151" title="Informace o&nbsp;produktu">
      Informace o&nbsp;produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14168" title="Pozn&aacute;mky k vyd&aacute;n&iacute;">
      Pozn&aacute;mky k vyd&aacute;n&iacute;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_cs" title="Ochrann&eacute; zn&aacute;mky">
      Ochrann&eacute; zn&aacute;mky
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_cs" title="Licenčn&iacute; informace">
      Licenčn&iacute; informace
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_cs" title="&Uacute;rovně hluku">
      &Uacute;rovně hluku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_cs" title="Směrnice OEEZ (o odpadn&iacute;ch elektrick&yacute;ch a elektronick&yacute;ch zař&iacute;zen&iacute;ch)">
      Směrnice OEEZ (o odpadn&iacute;ch elektrick&yacute;ch a elektronick&yacute;ch zař&iacute;zen&iacute;ch)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14265" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_cs" title="Likvidace produktu">
      Likvidace produktu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14299" title="Lithium-iontov&aacute; nab&iacute;jec&iacute; baterie">
      Lithium-iontov&aacute; nab&iacute;jec&iacute; baterie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_cs" title="Nař&iacute;zen&iacute; (EU) 2023/1542">
      Nař&iacute;zen&iacute; (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_cs" title="Vr&aacute;cen&iacute; kazet Lexmark za &uacute;čelem opětovn&eacute;ho použit&iacute; nebo recyklace">
      Vr&aacute;cen&iacute; kazet Lexmark za &uacute;čelem opětovn&eacute;ho použit&iacute; nebo recyklace
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_cs" title="Upozorněn&iacute; na citlivost vůči statick&eacute; elektřině">
      Upozorněn&iacute; na citlivost vůči statick&eacute; elektřině
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_cs" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_cs" title="Informace o teplotě">
      Informace o teplotě
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_cs" title="Upozorněn&iacute; ohledně laseru">
      Upozorněn&iacute; ohledně laseru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_cs" title="Spotřeba energie">
      Spotřeba energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14550" title="Z&aacute;konn&eacute; požadavky t&yacute;kaj&iacute;c&iacute; se bezdr&aacute;tov&yacute;ch v&yacute;robků">
      Z&aacute;konn&eacute; požadavky t&yacute;kaj&iacute;c&iacute; se bezdr&aacute;tov&yacute;ch v&yacute;robků
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_cs" title="Pozn&aacute;mka k modul&aacute;rn&iacute;m komponent&aacute;m">
      Pozn&aacute;mka k modul&aacute;rn&iacute;m komponent&aacute;m
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_cs" title="Vystaven&iacute; z&aacute;řen&iacute; r&aacute;diov&yacute;ch vln">
      Vystaven&iacute; z&aacute;řen&iacute; r&aacute;diov&yacute;ch vln
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e14576" title="Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU">
      Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_cs" title="Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU">
      Prohl&aacute;&scaron;en&iacute; o&nbsp;dodržen&iacute; směrnic EU
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue